import { api } from './api'

export const feedbackService = {
    getAll: () => api.get('/feedback'),
    updateStatus: (id, status) => api.patch(`/feedback/${id}`, { status }),
    remove: (id) => api.delete(`/feedback/${id}`),
}
